import { Container, Content, TextWrapper } from './styles'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'
import constantsGift from '../../../assets/constants/constantsGift'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

export function PlanDescription( { categorySelected, titlePlan, valueSaved, gifts } ) {
  const gift = gifts[ categorySelected === 2 ? 'ineditos' : 'curadoria' ]

  return (
    <Container>
      <Typography
        as="h2"
        color="cinza500"
        fontWeight="xl"
        variant="heading1"
      >Plano {titlePlan.toLowerCase()}
      </Typography>
      <Content>
        { titlePlan === 'Anual' ?
          <>
            { constantsGift.YEARLY.ACTIVE && (
              <GatsbyImage
                image={ getImage( gift.thumbnailImage.localFile ) }
                alt={ gift.text }
              />
            ) }
            <TextWrapper>
              <Typography
                as="p"
                color="cinza500"
                fontSizeDesktop="s"
                fontSizeMobile="xxs"
                fontWeight="xl"
                variant="customText"
              >
                Economize R$ {valueSaved.toFixed( 2 ).replace( '.', ',' )}
              </Typography>
              <Typography
                as="p"
                color="cinza500"
                fontSizeDesktop="s"
                fontSizeMobile="xxs"
                fontWeight="xl"
                variant="customText"
              >
                { constantsGift.YEARLY.ACTIVE && gift.title }
              </Typography>
              <Typography
                as="p"
                color="cinza400"
                fontSizeDesktop="xxxs"
                fontSizeMobile="xxxs"
                fontWeight="s"
                variant="customText"
              >
                { constantsGift.YEARLY.ACTIVE && constantsGift.YEARLY.IMAGE_OBSERVATION }
              </Typography>
            </TextWrapper>
          </> :
          <>
            { constantsGift.MONTHLY.ACTIVE && (
              <GatsbyImage
                image={ getImage( gift.thumbnailImage.localFile ) }
                alt={ gift.text }
              />
            ) }
            <TextWrapper>
              <Typography
                as="p"
                color="cinza500"
                fontSizeDesktop="s"
                fontSizeMobile="xxs"
                fontWeight="xl"
                variant="customText"
              >
                Assinatura recorrente com cobrança automática
              </Typography>
              <Typography
                as="p"
                color="cinza500"
                fontSizeDesktop="s"
                fontSizeMobile="xxs"
                fontWeight="xl"
                variant="customText"
              >
                { constantsGift.MONTHLY.ACTIVE && `${constantsGift.MONTHLY.PREFIX} ${gift.title}` }
              </Typography>
              <Typography
                as="p"
                color="cinza400"
                fontSizeDesktop="xxxs"
                fontSizeMobile="xxxs"
                fontWeight="s"
                variant="customText"
              >
                { constantsGift.MONTHLY.ACTIVE && constantsGift.MONTHLY.IMAGE_OBSERVATION }
              </Typography>
            </TextWrapper>
          </> }
      </Content>
    </Container>
  )
}

PlanDescription.propTypes = {
  'categorySelected': PropTypes.number.isRequired,
  'titlePlan': PropTypes.string.isRequired,
  'valueSaved': PropTypes.number
}

PlanDescription.defaultProps = {
  'valueSaved': 0,
}
